export const verticalAlignCenterIcon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9 19v-4.2l-1.6 1.6L6 15l4-4 4 4-1.4 1.4-1.6-1.6V19zm-8-8V9h18v2zm9-2L6 5l1.4-1.4L9 5.2V1h2v4.2l1.6-1.6L14 5z"/></svg>`,
  name: 'vertical-align-center',
};
